import { render } from "./AddEmergencyContacts.vue?vue&type=template&id=6b128e0e"
import script from "./AddEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./AddEmergencyContacts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__